import { PusherApi } from 'api/pushes/http';
import { isLocalhost } from 'utils/is-localhost';
import { isOrbitsEnvironment } from 'utils/is-nitro-env';
import { buildHeartbeatPayload, setHeartbeatAccountId } from './store';
const INTERVAL_MS = 30000;
let intervalId = null;
let refreshWorkerStats = null;
export const registerPusherWorkerStatsRefresh = (fn)=>{
    refreshWorkerStats = fn;
};
export const shouldSendPusherHeartbeat = ()=>!isLocalhost() && !isOrbitsEnvironment();
export const startPusherHeartbeat = (accountId)=>{
    setHeartbeatAccountId(accountId);
    if (!shouldSendPusherHeartbeat() || intervalId != null) {
        return;
    }
    const tick = ()=>{
        refreshWorkerStats === null || refreshWorkerStats === void 0 ? void 0 : refreshWorkerStats();
        PusherApi.heartbeat(buildHeartbeatPayload()).catch(()=>undefined);
    };
    intervalId = setInterval(tick, INTERVAL_MS);
    tick();
};
export const stopPusherHeartbeat = ()=>{
    if (intervalId != null) {
        clearInterval(intervalId);
        intervalId = null;
    }
};
